import React, { useEffect } from 'react';
import { connect } from 'react-redux';

// import Grid from '@mui/material/Grid';
// import ManufacturerIcon from '@mui/icons-material/FactoryOutlined';

import { ManufacturersTableContainer } from '../../components/manufacturers';
// import StatsBox from '../../components/shared/StatsBox';

import { fetchManufacturers } from '../../actions/adminActions';

import './admin.scss';

const ManufacturersPage = ({ fetchManufacturers, manufacturers, countries, users }) => {
  useEffect(() => {
    fetchManufacturers();
  }, [fetchManufacturers])

  return (
    <div className="admin-page">
      {/*<Grid container spacing={3} sx={{ mb: 3 }}>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Manufacturers' number={manufacturers?.length} icon={<ManufacturerIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Manufacturers' number={manufacturers?.length} icon={<ManufacturerIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Manufacturers' number={manufacturers?.length} icon={<ManufacturerIcon />} />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}
      <ManufacturersTableContainer
        manufacturers={manufacturers}
        countries={countries}
        users={users}
        withButton
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  manufacturers: state.manufacturers.list,
  countries: state.countries.list,
  users: state.users.list,
});

const mapDispatchToProps = (dispatch) => ({
  fetchManufacturers: () => dispatch(fetchManufacturers()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManufacturersPage);
